module.exports = __webpack_public_path__ + "img/exporter.556e021f.svg";